<template>
    <div>
        <div class="comments-count">
            <i v-if="rating.comments.length === 0" class="fa fa-comment-o"/>
            <i v-if="rating.comments.length === 1" class="fa fa-comment"/>
            <i v-if="rating.comments.length > 1" class="fa fa-comments"/>
            <span>{{ rating.comments.length }} Kommentar{{ rating.comments.length !== 1 ? 'e' : '' }}</span>
        </div>
        <div class="comments-for-solution-rating">
            <comment-for-solution-rating-form
                @successful="updateComments"
                :solution-rating-id="rating.ratingId">
            </comment-for-solution-rating-form>
            <div :v-if="rating.comments && rating.comments.length !== 0" class="row">
                <div class="col-lg-12">
                    <div v-for="(commentForSolutionRating, index) in rating.comments"
                         v-bind:key="commentForSolutionRating.id">
                        <div v-if="index < numberOfCommentsToShowFirst" class="comment-for-solution-rating"
                             :class="{'is-your-comment': commentForSolutionRating.isYourComment, 'new-added': commentForSolutionRating.newAdded, 'selected': commentForSolutionRating.id === selectedCommentId}"
                             :id="commentForSolutionRating.id"
                        >
                            <router-link class="comment-user"
                                         target="_blank"
                                         :to="{ name: 'public-user-profile', params: { userId: rating.publicId }}">
                                <i class="fa fa-comment"/>
                                <strong
                                    class="comment-for-solution-rating-name">{{ getUserName(commentForSolutionRating.publicUserId) }}</strong>
                            </router-link>
                            <div class="date">{{ getNiceTime(commentForSolutionRating.timeCreated) }}</div>
                            <p class="comment-for-solution-rating-text">
                                {{ commentForSolutionRating.text }}
                            </p>
                        </div>
                    </div>
                    <div class="more-comments-for-solution-rating" :class="{'hidden': !showMoreComments}">
                        <div v-for="(commentForSolutionRating, index) in rating.comments"
                             v-bind:key="commentForSolutionRating.id">
                            <div v-if="index >= numberOfCommentsToShowFirst" class="comment-for-solution-rating"
                                 :class="{'is-your-comment': commentForSolutionRating.isYourComment, 'selected': commentForSolutionRating.id === selectedCommentId}"
                             :id="commentForSolutionRating.id"
                        >
                                <router-link class="comment-user"
                                             target="_blank"
                                             :to="{ name: 'public-user-profile', params: { userId: rating.publicId }}">
                                    <i class="fa fa-comment"/>
                                    <strong
                                        class="comment-for-solution-rating-name">{{ getUserName(commentForSolutionRating.publicUserId) }}</strong>
                                </router-link>
                                <div class="date">{{ getNiceTime(commentForSolutionRating.timeCreated) }}</div>
                                <p class="comment-for-solution-rating-text">
                                    {{ commentForSolutionRating.text }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="rating.comments.length > numberOfCommentsToShowFirst" class="show-more-comments-button"
                         @click="toggleShowMoreComments()">
                        {{ showMoreComments ? 'weniger' : 'mehr' }} anzeigen
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommentForSolutionRatingForm from "./CommentForSolutionRatingForm";
import {eventBus, services} from "../../main";

export default {
    name: "SolutionRatingComments",
    components: {CommentForSolutionRatingForm},
    props: {
        rating: {type: Object, required: true,},
        selectedCommentId: {type: String, required: false,},
        getUserName: {type: Function},
        getNiceTime: {type: Function},
    },
    data() {
        return {
            showMoreComments: false,
            numberOfCommentsToShowFirst: 3,
        }
    },
    mounted() {
      if (this.selectedCommentId) {
        const commentIndex = this.rating.comments.findIndex(comment => comment.id === this.selectedCommentId);
        this.showMoreComments = commentIndex >= this.numberOfCommentsToShowFirst;
        const element = document.getElementById(this.selectedCommentId);
        if (element) {
          this.$nextTick(() => {
            element.scrollIntoView({block: "center", inline: "nearest"});
          });
        }
      }
    },
    methods: {
        toggleShowMoreComments: function () {
            this.showMoreComments = !this.showMoreComments;
        },
        updateComments: function (data) {
            const commentId = data.commentId;
            const publicUserId = data.publicUserId;
            const text = data.text;
            this.rating.comments.unshift({
                "id": commentId,
                "isYourComment": true,
                "publicUserId": publicUserId,
                "text": text,
                "timeCreated": new Date().toISOString(),
                "newAdded": true,
            });
            this.$emit("newCommentAdded", 1);
        },
    }
}
</script>

<style scoped>
.comments-count {
    font-size: smaller;
    cursor: default;
}

.comments-for-solution-rating {
    height: 100%;
    transition: all 0.25s ease-in-out;
}

.more-comments-for-solution-rating.hidden {
    height: 0;
}

.show-more-comments-button {
    font-size: smaller;
    color: #333;
    cursor: pointer;
    margin: 0 0 1rem 0;
}

.comment-for-solution-rating {
    padding: 7px 12px;
    display: inline-block;
    background-color: #F8FBFECC;
    margin-bottom: 0.7rem;
    margin-left: 0.7rem;
    width: calc(100% - 1.5rem);
    border-radius: 10px;
}

.selected .comment-for-solution-rating {
  background-color: transparent;
}

.comment-for-solution-rating.selected,
.selected .comment-for-solution-rating.selected{
  background-color: #fadccc;
}

.date {
    font-size: smaller;
    margin-bottom: .5rem;
    color: grey;
    display: flex;
    justify-items: center;
}

.comment-user:hover {
    cursor: pointer;
}

.comment-user strong {
    white-space: -moz-pre-wrap; /* Firefox */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* Chrome */
    word-wrap: break-word; /* IE */
}

.comments-count i,
.comment-user i {
    margin-right: 0.5rem;
}

@media (max-width: 576px) {
    .comments-count,
    .comments-for-solution-rating {
        margin-left: 0;
    }

    .date {
        flex-direction: column;
    }
}

.comment-for-solution-rating.new-added {
    background-image: none !important;
    -o-animation: fadeIt 1s ease-out;
    animation: fadeIt 1s ease-out;
}

@-o-keyframes fadeIt {
    0% {
        background-color: transparent;
        opacity: 0;
    }
    50% {
        background-color: rgba(0, 191, 143, 0.5);
        opacity: 1;
    }
    100% {
        background-color: #F8FBFECC;
    }
}

@keyframes fadeIt {
    0% {
        background-color: transparent;
        opacity: 0;
    }
    50% {
        background-color: rgba(0, 191, 143, 0.5);
        opacity: 1;
    }
    100% {
        background-color: #F8FBFECC;
    }
}
</style>